import { useSelector } from 'react-redux';

import { Divider, Box } from '@mui/material';
import { useTranslation } from 'next-i18next';

import CourseNotFoundSuggestionMessage from './courseNotFoundSuggestionMessage';
import CourseNotFoundWithFilterMessage from './courseNotFoundWithFilterMessage';
import Style from './style';

import CourseList from 'src/components/molecules/courseList';
import CourseResultHeader from 'src/components/organisms/courseResult/courseResultHeader';
import { RootState } from 'src/redux/reducer';

type Props = {
  courseApiResponse: any;
  loadMoreCount: number;
  isShowSuggestion: boolean;
  showNumberOfCourse?: boolean;
};

const CourseResult = ({ courseApiResponse, loadMoreCount, isShowSuggestion, showNumberOfCourse = false }: Props) => {
  const { t } = useTranslation('common');
  const { courseApiQueries }: any = useSelector((state: RootState) => ({
    courseApiQueries: state.Course.get('courseApiQueries'),
  }));
  let numberOfCourse = 0;
  let isDataNotFound = false;
  let isDataCourseIncludeNotFound = false;
  const { data } = courseApiResponse;
  if (data) {
    numberOfCourse = data[data.length - 1].data.count;
    isDataNotFound = data[data.length - 1].data.notFound;
    isDataCourseIncludeNotFound = data[data.length - 1].data.courseIncludeNotFound;
  }

  if (!isShowSuggestion && isDataNotFound) {
    return (
      <Style>
        <Box sx={{ my: 1, mx: 2 }}>
          <CourseResultHeader numberOfCourse={numberOfCourse} showNumberOfCourse={showNumberOfCourse} />
        </Box>
        <Divider variant="middle" sx={{ mt: { lg: 0, md: 3 } }} />
        <CourseNotFoundWithFilterMessage
          title={t('search_course.filter_course_not_found.title', { search_keyword: courseApiQueries.q })}
        />
      </Style>
    );
  }
  return (
    <Style>
      <Box sx={{ my: 1, mx: 2 }}>
        <CourseResultHeader numberOfCourse={numberOfCourse} showNumberOfCourse={showNumberOfCourse} />
      </Box>
      <Divider variant="middle" sx={{ mt: { lg: 0, md: 3 } }} />
      {isDataCourseIncludeNotFound && (
        <Box sx={{ mt: 4, mx: 2, textAlign: 'center' }}>
          <CourseNotFoundWithFilterMessage title={t('search_course.filter_course_not_found.select_filter')} />
        </Box>
      )}
      {isDataNotFound && isShowSuggestion && (
        <Box sx={{ mt: 4, mx: 2 }}>
          <CourseNotFoundSuggestionMessage />
        </Box>
      )}
      <Box sx={{ mt: { lg: 4, xs: 2 }, mx: '8px' }}>
        <CourseList courseApiResponse={courseApiResponse} loadMoreCount={loadMoreCount} />
      </Box>
    </Style>
  );
};

export default CourseResult;
